<template>
  <div class="unmatch">
    <van-nav-bar title="员工认证" left-arrow @click-left="back" />
    <div class="wrap">
      <svg-icon icon-class="err" />
      <p>未匹配到您的员工信息</p>

      <div class="tip">
        <span>温馨提示：</span>
        <p>1、请联系管理员在系统后台添加您的员工信息后再进行员工认证；</p>
        <p>2、后台录入的手机号须与您绑定的手机号一致。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unmatch',
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.unmatch {
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 0.7rem;
    font-size: 0.14rem;
    color: #333;
    .tip {
      text-align: left;
      margin-top: 0.2rem;
      padding: 0 0.27rem;
      line-height: 0.28rem;
      span {
        color: #f2b230;
        line-height: 0.3rem;
      }
      p {
        color: #888;
      }
    }
  }
}
</style>
